import React from 'react';
import styled, { css } from 'styled-components';
import DefaultCard from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import DefaultCardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import { Link as ReactRouterLink } from 'react-router-dom';
import _ from 'lodash';

import AppShell from '../../components/AppShell';
import Loader from '../../components/Loader';
import BarGraph from '../../components/BarGraph';
import PieChart from '../../components/PieChart';

const colors = ['#651FFF', '#2979FF', '#9C27B0', '#03A9F4', '#E91E63', '#8BC34A'];
const stages = [
  {
    value: 'registration',
    label: 'Registration',
  },
  {
    value: 'knowledgeTest',
    label: 'Knowledge Test',
  },
  {
    value: 'groupDiscussion',
    label: 'Group Discussion',
  },
  {
    value: 'personalInterview',
    label: 'Personal Interview',
  },
  {
    value: 'researchActivity',
    label: 'Research Activity',
  },
  {
    value: 'selected',
    label: 'Selected',
  },
];

class Dashboard extends React.Component {
  state = {
    aggregatedDataLoaded: false,
    aggregatedData: null,
    graphsData: null,
    graphsDataLoaded: false,
    activeStage: 'registration',
  };

  componentDidMount() {
    this.loadAggregatedData();
    this.loadGraphsData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.activeStage !== prevState.activeStage) {
      this.loadGraphsData();
    }
  }

  loadAggregatedData = async () => {
    this.setState({ aggregatedDataLoaded: false });
    try {
      const { success, data } = await fetch(
        'https://us-central1-jyp-admin-saas.cloudfunctions.net/dashboard/aggregated',
      ).then(response => response.json());
      if (success) {
        this.setState({ aggregatedDataLoaded: true, aggregatedData: data });
      } else {
        this.setState({ aggregatedDataLoaded: true, aggregatedData: null });
      }
    } catch (error) {
      this.setState({ aggregatedDataLoaded: true, aggregatedData: null });
    }
  };

  loadGraphsData = async () => {
    this.setState({ graphsDataLoaded: false });
    try {
      const { success, data } = await fetch(
        `https://us-central1-jyp-admin-saas.cloudfunctions.net/dashboard/?stage=${
          this.state.activeStage
        }`,
      ).then(response => response.json());
      if (success) {
        this.setState({ graphsData: data, graphsDataLoaded: true });
      } else {
        this.setState({ graphsDataLoaded: true, graphsData: null });
      }
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
      this.setState({ graphsDataLoaded: true, graphsData: null });
    }
  };

  render() {
    return (
      <AppShell>
        {(!this.state.graphsDataLoaded || !this.state.aggregatedDataLoaded) && <Loader />}
        <div>
          {this.state.aggregatedData && (
            <CardsContainer>
              {this.state.aggregatedData.map((data, index) => (
                <Card key={data.id} background={colors[index]}>
                  <CardContent>
                    <CardTitle>{data.label}</CardTitle>
                    <Spacer />
                    <Typography variant="display1">{data.value}</Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      size="small"
                      component={ReactRouterLink}
                      to={`/selection-stage/${data.id}`}
                    >
                      View Stage
                    </Button>
                  </CardActions>
                </Card>
              ))}
            </CardsContainer>
          )}
          <TabsContainer>
            <Tabs
              value={_.findIndex(stages, { value: this.state.activeStage })}
              onChange={(event, value) => {
                const stage = stages[value];
                this.setState({ activeStage: stage.value });
              }}
            >
              {stages.map(stage => <Tab label={stage.label} key={stage.value} />)}
            </Tabs>
          </TabsContainer>
          {this.state.graphsData && (
            <GraphsContainer>
              {this.state.graphsData.map((graph) => {
                const {
                  id, type, colSpan, ...config
                } = graph;
                return (
                  <GraphContainer key={graph.id} fullWidth={colSpan === 2}>
                    {type === 'BAR' ? (
                      <BarGraph config={config} />
                    ) : type === 'PIE' ? (
                      <PieChart config={config} />
                    ) : null}
                  </GraphContainer>
                );
              })}
            </GraphsContainer>
          )}
        </div>
      </AppShell>
    );
  }
}

export default Dashboard;

const GraphsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
`;

const Card = styled(DefaultCard)`
  display: flex;
  flex-direction: column;
  && {
    background-color: ${props => props.background};
  }
`;

const CardContent = styled(DefaultCardContent)`
  display: flex;
  flex: 1;
  flex-direction: column;

  & * {
    color: ${props => props.theme.palette.primary.contrastText} !important;
  }
`;

const Spacer = styled.div`
  display: flex;
  flex: 1;
`;

const GraphContainer = styled.div`
  ${props => props.fullWidth
    && css`
      grid-column-start: 1;
      grid-column-end: 3;
    `};
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
  margin-bottom: 40px;
`;

const CardTitle = styled(Typography).attrs({
  variant: 'subheading',
})`
  && {
    margin-bottom: 16px;
  }
`;

const TabsContainer = styled(Paper).attrs({
  elevation: 4,
})`
  margin-bottom: 16px;

  && {
    background: ${props => props.theme.palette.primary.main};
  }

  & * {
    color: ${props => props.theme.palette.primary.contrastText} !important;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Dashboard/Dashboard.js